import styled from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const GuestPopupWrapper = styled.div<{ theme: Theme }>`
  .register-button {
    display: block;
    margin: 16px auto 0;
  }

  .email-input {
    padding: 8px 16px;
    margin-bottom: 16px;
    width: -webkit-fill-available;

    &.email-input:focus-visible {
      border: 1px solid ${getColor('neutralBlack')};
      outline: unset;
    }
  }

  .arrow-svg {
    width: 32px;
    height: 12px;
    transform: rotate(90deg);
  }

  .internal-page-link {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    text-decoration: underline;
    color: ${getColor('textLink')};
    padding: 0;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const AccountWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;

  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
`;

export const LinkButton = styled.button<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: ${getColor('textLink')};

  &.login-button {
    margin-right: 8px;
    padding: 0 !important;
  }

  &.create-button {
    margin-left: 8px;
    padding: 0 !important;
  }
`;

export const SeparatorWrapper = styled.div<{ theme: Theme }>`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;

  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;

  .line {
    border: 0.5px solid ${getColor('neutralDarkGray')};
    width: 28%;
    margin: auto 0;

    @media (${breakpoint.mdMin}) {
      width: 30%;
    }
  }
`;

export const Subtitle = styled.div`
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-top: 16px;
  margin-bottom: 8px;
  text-align: left;
`;

export const FormWrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr 1fr;
  }

  .email-input {
    &.error {
      outline: unset;
      border: 1px solid ${color.primaryRed};
    }
  }

  .country-input {
    text-align: left;
    margin-right: 2px;

    @media (${breakpoint.mdMin}) {
      margin-bottom: 8px;
    }
    &.error > div:nth-of-type(1) {
      border: 1px solid ${color.primaryRed};
    }
    > div:last-child {
      @media (${breakpoint.mdMin}) {
        margin: 0;
      }
      > div {
        max-height: 232px;
        @media (${breakpoint.mdMin}) {
          max-height: 210px;
        }
      }
    }
  }
`;

export const EmailError = styled.span`
  display: block;
  color: ${color.primaryRed};
  text-align: left;

  margin-top: 8px;
  font-size: 12px;
  margin-bottom: -12px;
  min-height: 14px;

  @media (${breakpoint.mdMin}) {
    margin-top: -8px;
    font-size: 14px;
    margin-bottom: 0;
    min-height: 20px;
  }
`;

export const PolicyWrapper = styled.div`
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.5px;
  text-align: left;

  @media (${breakpoint.mdMax}) {
    margin-top: 16px;
  }

  .checkbox {
    margin-top: 16px;

    label {
      font-family: ${font.graphikCond};
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      letter-spacing: 0.5px;
      text-transform: unset;
      position: relative;

      .required {
        display: contents;
      }
    }
  }
`;
